class G3DHondaGraphics extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.catalog = JSON.parse(this.querySelector('[data-catalog]').textContent);
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.forkVariants = JSON.parse(this.querySelector('[data-fork-variants]').textContent);
    this.state = {bike:null,year:null,graphic:null,rims:null,rimColor:null,spokes:null,spokeColor:null,forks:null,forkBrand:null,forkVariant:null};
    this.form = this.querySelector('form');
    this.querySelectorAll('[data-bike]').forEach(button=>button.addEventListener('click',()=>{this.state.bike=button.dataset.bike;this.update();}));
    this.querySelectorAll('[data-year]').forEach(button => button.addEventListener('click', () => {
      if (this.state.year !== button.dataset.year) {
        this.state.year = button.dataset.year;
        this.state.graphic = null;
        this.renderCards('graphic', this.catalog.filter(x => x.group === this.state.year));
      }
      this.update();
    }));
    ['rims','spokes'].forEach(kind => this.querySelectorAll('[data-'+kind+']').forEach(button => button.addEventListener('click', () => {
      this.state[kind] = button.dataset[kind] === 'yes';
      if (this.state[kind] && !this.querySelector('[data-'+kind+'-choices]').children.length) {
        this.renderCards(kind,this.catalog.filter(x => x.group === (kind === 'rims' ? 'ADESIVI_CERCHI' : 'COPRI_RAGGI')));
      }
      this.update();
    })));
    this.querySelectorAll('[data-forks]').forEach(button => button.addEventListener('click', () => {
      this.state.forks = button.dataset.forks === 'yes';
      if (this.state.forks) {
        if (!this.state.forkVariant) this.state.forkVariant = this.forkVariants[0] || null;
        if (this.state.forkVariant) this.state.forkBrand = this.state.forkVariant.brand;
        this.renderForkChoices();
      }
      this.update();
    }));
    this.querySelectorAll('[data-fork-brand]').forEach(button => button.addEventListener('click', () => {
      const brand = button.dataset.forkBrand;
      const match = this.forkVariants.find(v => v.brand === brand);
      if (!match) return;
      this.state.forkBrand = brand;
      this.state.forkVariant = match;
      this.renderForkChoices();
      this.update();
    }));

    this.form.addEventListener('submit', event => {
      if (!this.validForPurchase) {event.preventDefault();event.stopImmediatePropagation();return;}
      event.preventDefault();event.stopImmediatePropagation();this.addBundle();
    });
    this.update();
  }
  renderCards(kind, entries) {
    const container = this.querySelector('[data-'+kind+'-choices]');
    container.replaceChildren();
    for (const entry of entries) {
      const button = document.createElement('button');button.type = 'button';button.dataset.entry = entry.code;
      button.setAttribute('aria-pressed','false');button.setAttribute('aria-label',entry.name);
      const image = document.createElement('img');
      const thumbnail = new URL(entry.url, window.location.origin);thumbnail.searchParams.set('width','320');
      image.src = thumbnail.href;image.alt = entry.name;image.width = 160;image.height = 160;image.loading = 'lazy';image.decoding = 'async';
      const label = document.createElement('span');label.textContent = kind === 'forks' ? entry.graphic : entry.name;
      button.append(image,label);
      button.addEventListener('click', () => {
        this.state[kind === 'graphic' ? 'graphic' : kind === 'rims' ? 'rimColor' : kind === 'spokes' ? 'spokeColor' : 'forkVariant'] = entry;
        if (kind === 'forks') this.state.forkBrand = entry.brand;
        this.update();
      });
      container.append(button);
    }
  }
  renderForkChoices() {
    const brand = this.state.forkBrand || this.state.forkVariant?.brand || this.forkVariants[0]?.brand;
    if (!brand) return;
    this.state.forkBrand = brand;
    const entries = this.forkVariants.filter(v => v.brand === brand);
    this.renderCards('forks', entries);
    const label = this.querySelector('[data-fork-graphics-label]');
    if (label) label.textContent = entries.length < 2 ? 'Grafica selezionata' : 'Scegli grafica';
  }
  preview(kind, entry, show) {
    const name = kind === 'graphic' ? 'main' : kind;
    const wrapper = this.querySelector('[data-'+name+'-preview]');wrapper.hidden = !show;
    if (!show || !entry) return;
    const image = this.querySelector('[data-'+name+'-image]');
    if (image.getAttribute('src') !== entry.url) image.src = entry.url;
    image.alt = (kind === 'graphic' ? this.state.bike+' '+this.state.year+' ' : kind === 'rims' ? 'Adesivi cerchi ' : kind === 'spokes' ? 'Copri raggi ' : 'Adesivi forcelle ') + entry.name;
    this.querySelector('[data-'+name+'-caption]').textContent = kind === 'graphic' ? this.state.year.replace('-', '–')+' · '+entry.name : entry.name;
  }
  formatMoney(cents) {
    return new Intl.NumberFormat('it-IT',{style:'currency',currency:this.dataset.currency || 'EUR'}).format((Number(cents)||0)/100);
  }
  async addBundle() {
    if (this.isAdding || !this.validForPurchase) return;
    this.isAdding = true;
    const button=this.querySelector('[data-buy]');button.disabled=true;
    const note=this.querySelector('[data-price-note]');
    try {
      const mainId=this.form.querySelector('[name=id]').value;
      const properties={};
      this.querySelectorAll('[data-properties] input:not([disabled])').forEach(input=>{
        const match=input.name.match(/^properties\[(.*)\]$/);if(match)properties[match[1]]=input.value;
      });
      const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      const items=[{id:Number(mainId),quantity:1,properties}];
      if(this.state.forks&&this.state.forkVariant)items.push({id:Number(this.state.forkVariant.id),quantity:1});

      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.description||'Impossibile aggiungere la configurazione al carrello.');}
      window.location.href=root+'cart';
    } catch(error) {
      this.isAdding=false;button.disabled=false;note.hidden=false;note.textContent=error.message||'Impossibile aggiungere la configurazione al carrello.';
    }
  }
  update() {
    const s=this.state;
    const complete=!!(s.bike&&s.year&&s.graphic&&(s.rims===false||(s.rims&&s.rimColor))&&(s.spokes===false||(s.spokes&&s.spokeColor))&&(s.forks===false||(s.forks&&s.forkVariant)));
    this.querySelector('[data-year-step]').hidden=!s.bike;
    this.querySelector('[data-graphic-step]').hidden=!s.year;
    for(const kind of ['rims','spokes','forks']){
      this.querySelector('[data-'+kind+'-step]').hidden=!s.graphic;
      this.querySelector('[data-'+kind+(kind==='forks'?'-options':'-colors')+']').hidden=s[kind]!==true;
      this.querySelectorAll('[data-'+kind+']').forEach(b=>b.setAttribute('aria-pressed',String(s[kind]!==null&&s[kind]===(b.dataset[kind]==='yes'))));
    }
    this.querySelector('[data-summary]').hidden=!s.graphic;
    this.querySelectorAll('[data-bike]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.bike===s.bike)));
    this.querySelectorAll('[data-year]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.year===s.year)));
    this.querySelectorAll('[data-fork-brand]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.forkBrand===s.forkBrand)));
    for(const [kind,entry] of [['graphic',s.graphic],['rims',s.rimColor],['spokes',s.spokeColor],['forks',s.forkVariant]]){
      this.querySelector('[data-'+kind+'-choices]').querySelectorAll('[data-entry]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.entry===entry?.code)));
      this.preview(kind,entry,kind==='graphic'?!!entry:!!entry&&s[kind]===true);
    }
    const properties={'Moto':s.bike||'','Annata':'2002–2012','Grafica':s.graphic?.name||'','Codice grafica':s.graphic?.code||'','Adesivi cerchi':s.rims?'Sì':'No','Colore adesivi cerchi':s.rims?s.rimColor?.name||'':'—','Copri raggi':s.spokes?'Sì':'No','Colore copri raggi':s.spokes?s.spokeColor?.name||'':'—','Adesivi forcella':s.forks?'Sì':'No','Marca forcella':s.forks?s.forkVariant?.brand||'':'—','Grafica adesivi forcella':s.forks?s.forkVariant?.graphic||'':'—'};
    const summary=this.querySelector('[data-summary-values]');summary.replaceChildren();
    for(const [label,value] of Object.entries(properties)){
      if(label==='Codice grafica')continue;
      const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;row.append(dt,dd);summary.append(row);
    }
    const inputs=this.querySelector('[data-properties]');inputs.replaceChildren();
    for(const [name,value] of Object.entries(properties)){const input=document.createElement('input');input.type='hidden';input.name='properties['+name+']';input.value=value;input.disabled=!complete;inputs.append(input);}
    const variant=this.variants.find(v=>v.code===s.graphic?.code);
    const optionalUnavailable=s.rims===true||s.spokes===true;
    this.validForPurchase=complete&&!optionalUnavailable&&!!variant?.available&&(s.forks!==true||!!s.forkVariant?.available);
    const input=this.form.querySelector('[name=id]');input.value=variant?.id||'';input.disabled=!this.validForPurchase;
    this.querySelector('[data-buy]').disabled=!this.validForPurchase;
    const extras=(s.rims?Number(this.dataset.optionalPrice):0)+(s.spokes?Number(this.dataset.optionalPrice):0)+(s.forks?Number(s.forkVariant?.price||0):0);
    this.querySelector('[data-price]').textContent=variant?this.formatMoney(Number(variant.price)+extras):'Seleziona una grafica';
    this.querySelector('[data-compare-price]').hidden=true;
    const note=this.querySelector('[data-price-note]');note.hidden=this.validForPurchase;note.textContent=optionalUnavailable?'Adesivi cerchi e copri raggi: acquisto non ancora disponibile in questa anteprima.':variant&&!variant.available?'Questa grafica non è attualmente disponibile per l’acquisto.':'Completa le selezioni per aggiungere al carrello.';
  }
}
if (!customElements.get('g3d-honda-graphics')) customElements.define('g3d-honda-graphics',G3DHondaGraphics);



